import { reactive } from 'vue'

export const progressState = reactive({
  active: false,
  percent: 0,
  color: 'rgb(113, 67, 155)',
  height: '3px'
})

export function createProgressPlugin () {
  const progress = {
    start () {
      progressState.active = true
      progressState.percent = 30
      progressState.color = 'rgb(113, 67, 155)'
    },
    finish () {
      progressState.percent = 100
      setTimeout(() => {
        progressState.active = false
        progressState.percent = 0
      }, 200)
    },
    fail () {
      progressState.color = 'red'
      progress.finish()
    }
  }

  return {
    install (app) {
      app.config.globalProperties.$Progress = progress
    }
  }
}
